import _ from 'lodash';

export class DataTreeNode<TData>{
  id:string = '';
  parentId?: string ='';
  children?: DataTreeNode<TData>[]=[];
  data?:TData;
  isGroup:Boolean = false
  disabled:Boolean = false

  public static arrayToTree<TData>(array:DataTreeNode<TData>[]):DataTreeNode<TData>[]{
    const rootList = array.filter(c=>c.parentId===undefined || c.parentId == '0' || c.parentId==='' || c.parentId===null);

    const rootGropyBy:any = _.groupBy(array,(c:any)=>c.parentId);

    DataTreeNode.toTree<TData>(rootGropyBy,rootList);
    return rootList;
  }

  private static toTree<TData>(parentValue:any,rootNodeList:DataTreeNode<TData>[]){
    if(!rootNodeList){
      return ;
    }
    rootNodeList.forEach(c=>{
      const children:DataTreeNode<TData>[] = parentValue[c.id] || [];
      if(!c.children){
        c.children = [];
      }

      if(children.length>0){
        c.children.push(...children);
      }else{
        c.children = undefined;
      }

      DataTreeNode.toTree<TData>(parentValue,children);
    });
  }

  public static arrayTree<TData>(array:DataTreeNode<TData>[]):DataTreeNode<TData>[]{
    const rootList = array.filter(c=>c.parentId===undefined || c.parentId == '0' || c.parentId==='' || c.parentId===null);

    const rootGropyBy:any = _.groupBy(array,(c:any)=>c.parentId);

    DataTreeNode.toCheckTree<TData>(rootGropyBy,rootList);
    return rootList;
  }

  private static toCheckTree<TData>(parentValue:any,rootNodeList:DataTreeNode<TData>[]){
    if(!rootNodeList){
      return ;
    }
    rootNodeList.forEach(c=>{
      const children:DataTreeNode<TData>[] = parentValue[c.id] || [];
      if(!c.children){
        c.children = [];
      }
      if(children.length>0){
        c.disabled = true
        children.forEach(res =>{
          if(res.isGroup === false){
            c.disabled = false
          }
        })
        c.children.push(...children);
      }else{
        if(c.isGroup){
          c.disabled = true
        }
        c.children = undefined;
      }

      DataTreeNode.toCheckTree<TData>(parentValue,children);
    });
  }
}